import { Nullable } from "@/api/ApiClient";
import { WithReferenceCode } from "./ReferenceCodeType";

export type ReceivedInvoiceMessageData = WithReferenceCode<Nullable<{
    providerId: string,
    reference_number: string,
    documentType: "expense" | "providerInvoice" | "providerNote" | "expenseNote",
    documentNoteType: "credit" | "debit",
    documentId: string,
}>>
export type ReceivedInvoiceFormData = Nullable<{
    id: string,
    receivedEmailId: string,
    xmlInvoiceAttachmentId: string,
    xmlResponseAttachmentId: string,
    pdfAttachmentId: string,
    emisorIdentificacion: string,
    emisorNombre: string,
    receptorIdentificacion: string,
    receptorNombre: string,
    clave: string,
    sequence: string,
    fecha: string,
    currency: string,
    subtotal: number,
    descuento: number,
    impuestos: number,
    total: number,
    status: string,
    errorMessage: string,
    documentStatus: number,
    providerId: string,
    reference_number: string,
    documentType: string,
    documentNoteType: string,
    documentId: string,
} & ReceivedInvoiceMessageData>;

export const ReceivedInvoiceRelatedAttributes: Array<keyof ReceivedInvoiceFormData> = [];